module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-select-none tw-w-[500px] tw-max-w-[500px]"
  }, [_c('NotificationScroll', {
    class: {
      'tw-hidden': !_vm.listNotificationFiltred.length
    },
    attrs: {
      "flagScroll": _vm.flagList,
      "isHeader": true
    }
  }, _vm._l((_vm.listNotificationFiltred.slice().reverse()), function(notification) {
    return _c('NotificationItem', {
      key: notification.id,
      attrs: {
        "notification": notification,
        "canClose": false,
        "autoHide": false
      }
    })
  })), _vm._v(" "), (!_vm.listNotificationFiltred.length) ? _c('div', {
    staticClass: "tw-whitespace-nowrap tw-px-5 tw-pb-5 tw-pt-3 tw-flex tw-flex-col tw-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._v("Il n'y a eu aucune notification.")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fa-stack tw-text-2xl tw-flex tw-items-center tw-mb-1"
  }, [_c('span', {
    staticClass: "fa-solid fa-circle fa-stack-2x tw-text-gray-100"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa-regular fa-bell-slash fa-stack-1x tw-text-yellow-500"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a139d8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/notification/notification-list-header/notification-list-header.vue.html
// module id = 7Zgd
// module chunks = 2